import {LoginComponent} from '../components/login/login.component';
import {Routes} from '@angular/router';
import {AppComponent} from "../components/app/app.component";
import {MeasurementsComponent} from "../components/measurements/measurements.component";
import {MapDetailsComponent} from "../components/mapDetails/mapDetails.component";
import AuthService from "../services/auth.service";
import AdBlockService from "../services/adBlock.service";
import LoginService from "../services/login.service";

const routes: Routes = [
    {
        path: 'measurements',
        component: AppComponent,
        children: [{
            path: '',
            component: MeasurementsComponent,
        },
            {
                path: ':id/details',
                component: MapDetailsComponent,
            }
        ],
        canActivate: [AdBlockService, AuthService]
    },
    {
        path: 'login/:username/:passwordHash',
        component: LoginComponent,
        canActivate: [LoginService]
    },
    {
        path: '**',
        component: LoginComponent,
        canActivate: [LoginService]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/app/routes/routes.ts